import { HUB_EVENTS, hubEmitter } from '@/core/realtime';
import { messageListKeys } from '@/features/message-list';
import type { MessageListData } from '@/features/message-list';
import type { Message } from '@/features/messages/models/message';
import type { MessageDeleteForUser, MessageRecalledDto } from '@/features/messages/models/message-action-dto';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useMessageDeletionEvents = () => {
  const queryClient = useQueryClient();

  const remvStoredMsg = (conversationId: string, messageId: string, mode: 'delete' | 'recall' = 'delete') => {
    queryClient.setQueryData<MessageListData>(messageListKeys.conversation(conversationId!), (oldData) => {
      if (!oldData) return oldData;

      const filterMessage = (msg: Message) => msg.messageId !== messageId;

      if (oldData.pages) {
        return {
          ...oldData,
          pages: oldData.pages.map((page) => {
            if (mode === 'recall') {
              return page.map((msg) => {
                if (msg.messageId === messageId) {
                  return {
                    ...msg,
                    isRevoked: true,
                    content: 'Tin nhắn này đã bị thu hồi',
                    structuredAttachments: [],
                    reactionSummary: {}
                  };
                }
                return msg;
              });
            }
            return page.filter(filterMessage);
          })
        };
      }

      return oldData;
    });
  };

  const handleMsgRecalled = (dto: MessageRecalledDto) => remvStoredMsg(dto.conversationId, dto.messageId, 'recall');
  const handleMsgDelForUser = (dto: MessageDeleteForUser) => remvStoredMsg(dto.conversationId, dto.messageId);

  useEffect(() => {
    hubEmitter.on(HUB_EVENTS.MESSAGE.RECALLED, handleMsgRecalled);
    hubEmitter.on(HUB_EVENTS.MESSAGE.DELETED_FOR_USER, handleMsgDelForUser);

    return () => {
      hubEmitter.off(HUB_EVENTS.MESSAGE.RECALLED, handleMsgRecalled);
      hubEmitter.off(HUB_EVENTS.MESSAGE.DELETED_FOR_USER, handleMsgDelForUser);
    };
  }, [queryClient]);

  return {
    handleMessageRecalled: handleMsgRecalled,
    handleMessageDeletedForUser: handleMsgDelForUser
  };
};
